export class MobileService {
  private static readonly LARGURA_MAX_MOBILE = 768;

  public static isMobile(): boolean {
    return window.innerWidth < this.LARGURA_MAX_MOBILE;
  }
}
